/**
 * @author Sarthak Sharma.
 * @since 05-02-2024.
 * @type {string} Notifictions action types.
 */

export const SET_LOADING = '[RECRUITER_NOTIFICATION] SET_LOADING';
export const SET_NOTIFICATION_LIST = '[RECRUITER_NOTIFICATION] SET_NOTIFICATION_LIST';
export const APPEND_NOTIFICATION_LIST = '[RECRUITER_NOTIFICATION] APPEND_NOTIFICATION_LIST';
export const SET_NOTIFICATION_LIST_META = '[RECRUITER_NOTIFICATION] SET_NOTIFICATION_LIST_META';

